import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import * as defaultStyles from '../../../styles';
import { imageUrl } from '../../../utilities/requests';


export default class PrintStudentReport extends React.PureComponent {

    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    state = {
        chartCount: 0,
        chartAreaHeight: 0,
        pageHeight: "596mm",
        freeHeight: 0,
        materialTableHeight: 0,
        imgsrc: null
    }
    componentDidMount() {
        this.setState({ chartAreaHeight: this.chartArea.clientHeight ,materialTableHeight: this.materialTable.clientHeight});
    }

    questionsList() {
        return <>
            {
                <div ref={(questionAnswer)=> {this.questionAnswer = questionAnswer}}>
                    <div
                        style={{
                            textAlign: 'center',
                            width: '100%',
                            lineHeight: '1.8em',
                            // marginTop: `${this.state.freeHeight}mm`
                            // marginTop:0
                        }}>
                        {window.gettext('Question Index')} - {window.gettext('Material')} - {window.gettext('Subject')}&nbsp;
                        ({window.gettext('Correct Option')} - {window.gettext('Student Option')})&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <span style={{ color: 'green' }}>{window.gettext('Correct')}</span><span>{' '}</span>
                        <span style={{ color: 'red' }}>{window.gettext('Incorrect')}</span><span>{' '}</span>
                        <span style={{ color: 'black' }}>{window.gettext('Empty')}</span><span>{' '}</span>
                    </div>
                    <div
                        style={{
                            clear: 'both',
                            display: 'flex',
                            flexDirection: 'column',
                            flexWrap: 'wrap',
                            height: `${1.5 * Math.ceil(this.props.data.questions.length /
                                (this.props.data.questions.length > 60 ? 4 : 3))}em`,
                            fontSize: `${.9 - Math.max(_.size(this.props.examination.materials), 5) * .04}em`,
                            border: defaultStyles.table.border,
                            padding: '.5em',
                        }}>
                        {_.map(this.props.data.questions, (questionInfo, index) => {
                            if (!questionInfo)
                                return <div key={index} style={{ height: '1.7em', marginLeft: '.2em', color: 'blue' }}>
                                    {(index + 1).persian()} - {window.gettext('This question is removed.')}
                                </div>;
                            const material = questionInfo.material || '';
                            const subjects = questionInfo.subjects || [];
                            return <div key={index} style={{ height: '1.5em', marginLeft: '.2em' }}>
                                <span
                                    style={{
                                        color: this.props.data.answers[index]
                                            ? this.props.data.key[index] === this.props.data.answers[index]
                                                ? 'green'
                                                : 'red'
                                            : undefined,
                                    }}>
                                    {(index + 1).persian()}
                                </span>
                                &nbsp;- {material.length > 10 ? material.substring(0, 6) + '...' : material} - &nbsp;
                                {(text => text.length > 15
                                    ? text.substring(0, 19) + '...'
                                    : text)(subjects.join(window.gettext(',')))}&nbsp;
                                {Math.log2(this.props.data.key[index] * 2 || 1).toFixed().persian()} -&nbsp;
                                <span
                                    style={{
                                        color: this.props.data.answers[index]
                                            ? this.props.data.key[index] === this.props.data.answers[index]
                                                ? 'green'
                                                : 'red'
                                            : undefined,
                                    }}>
                                    {Math.log2(this.props.data.answers[index] * 2 || 1).toFixed().persian()}
                                </span>
                            </div>;
                        })}
                    </div>
                </div >
            }
        </>;
    }
    pxToMM(px){
        return  Number(px ?? "0")*25.6 / 96 
    }

    render() {
        let totalHeight =this?.materialTable?.clientHeight  
        // +this?.rankTable?.clientHeight 
         + this?.answers?.clientHeight  +
            this?.chartArea?.clientHeight  + this?.questionAnswer?.clientHeight 
        let totalHeightToMM = this.pxToMM(totalHeight) + 30
        if(totalHeightToMM > 296){
            const freeHeight = 296 - (totalHeightToMM - this.pxToMM(this?.questionAnswer?.clientHeight)) ;
            this.setState({ ...this.state ,pageHeight: "596mm" , freeHeight:freeHeight });
        }
        else{
            this.setState({ pageHeight: "296mm" })
        }

        const questionsPerColumn = this.props.examination.paper_type === 14 ? 26 : 15;
        const columns = this.props.examination.paper_type === 14 ? 6 : 8;
        let examinations = this.props.data.global.examinations;
        examinations = examinations.filter((exam)=> exam[2] === this.props.examination.examination_type.id)
        console.log("examinations",examinations)
        let minimumTaraz = _.min(_.map(examinations, i => i[1]));
        let maximumTaraz = _.max(_.map(examinations, i => i[1]));
        if (maximumTaraz - minimumTaraz < 2000) {
            minimumTaraz = (minimumTaraz + maximumTaraz) / 2 - 1000;
            maximumTaraz = (minimumTaraz + maximumTaraz) / 2 + 1000;
        }
        minimumTaraz = Math.round(minimumTaraz / 500) * 500;
        minimumTaraz = Math.round(minimumTaraz / 500) * 500;
        const materials = _.uniq(_.map(this.props.data.questions, 'material'));
        const showCoefficients = _.some(
            this.props.examination.materials_coefficients,
            value => value !== _.values(this.props.examination.materials_coefficients)[0],
        );
        return <>
            <div
                style={{
                    position: 'relative',
                    width: '210mm',
                    height: this.state.pageHeight,
                    pageBreakBefore: this.props.first ? undefined : 'always',
                    pageBreakAfter: this.props.last ? undefined : undefined,
                }}>
                <div
                    style={{
                        position: 'absolute',
                        top: '24mm',
                        right: '45mm',
                        width: '52mm',
                        fontSize: '1.65em',
                    }}>
                    <div style={{ textAlign: 'center' }}>
                        <b>{window.gettext('Student Report')}</b>
                    </div>
                </div>
                <div
                    style={{
                        position: 'absolute',
                        top: '9mm',
                        right: '104mm',
                        width: '67mm',
                        fontSize: '.9em',
                    }}>
                    {/* student name */}
                    <div style={{ overflow: 'hidden', height: '2.3em' }}>
                        <b>{window.gettext('Name')}:</b> {this.props.data.firstname} - {this.props.data.lastname}
                    </div>
                    {/* school name */}
                    <div style={{ overflow: 'hidden', height: '2.3em' }}>
                        <b>{window.gettext('School Name')}:</b> {this.props.data.school_display.persian()}
                    </div>
                    <div style={{ overflow: 'hidden', height: '2.3em' }}>
                        <b>{window.gettext('Examination')} - {window.gettext('Grade')}:</b>&nbsp;
                        {this.props.examination.title.persian()} - {this.props.data.grade_display.persian()}
                    </div>
                </div>
                <div
                    style={{
                        position: 'absolute',
                        top: '9mm',
                        right: '172mm',
                        width: '37mm',
                        fontSize: '.9em',
                    }}>
                    <div style={{ overflow: 'hidden', height: '2.3em' }}>
                        <b>{window.gettext('National ID')}:</b> {(this.props.data.national_id || '').persian()}
                    </div>
                    <div style={{ overflow: 'hidden', height: '2.3em' }}>
                        <b>{window.gettext('City')}:</b> {(this.props.data.city_display || '').persian()}
                    </div>
                    <div style={{ overflow: 'hidden', height: '2.2em' }}>
                        <b>{window.gettext('Class')}:</b> {(this.props.data.class_display || '').persian()}
                    </div>
                </div>
                {/* date */}
                <div
                    style={{
                        position: 'absolute',
                        bottom: `${this.state.pageHeight === "596mm" ? "8mm" : "0mm"}`,
                        right: '12mm',
                        // width: '56mm',
                    }}>
                    <div style={{ overflow: 'hidden', height: 'auto' }}>
                        <b>{window.gettext('Analyze Date')}:</b> {this.props.examination.analyze_date
                            ? this.props.examination.analyze_date.toJalali().persian()
                            : ''
                        }
                    </div>
                </div>
                {/* web address */}
                <div
                    style={{
                        position: 'absolute',
                        bottom: `${this.state.pageHeight === "596mm" ? "8mm" : "0mm"}`,
                        right: '88mm',
                        fontSize: '1.3em',
                        fontFamily: 'Arial',
                    }}>
                    <b>www.mhelli.com</b>
                </div>
                <div
                    style={{
                        position: 'absolute',
                        top: '34mm',
                        left: '12mm',
                        right: '7mm',
                    }}>
                    {/* start material table */}
                    <div style={{ display: "flex", justifyContent: "center", width: "100%", marginBottom: "0.2cm" }}>
                        <table
                            ref={(materialTable) => { this.materialTable = materialTable }}
                            style={{
                                ...defaultStyles.table,
                                fontSize: `${.9 - Math.max(_.size(this.props.examination.materials), 5) * .03}em`,
                                width:"100%"
                            }}>

                            <thead style={{ display: 'table-row-group' }}>
                                <tr style={{ ...defaultStyles.tr, backgroundColor: '#cccccc', fontWeight: '600' }}>
                                    <th
                                        rowSpan='2'
                                        style={{ ...defaultStyles.th, width: '12em' }}>
                                        {window.gettext('Material')}
                                    </th>
                                    {_.map(
                                        [
                                            ...showCoefficients ? ['coefficient'] : [],
                                            'count',
                                            'correct',
                                            'incorrect',
                                            'empty',
                                            'score',
                                            'alternative_score',
                                            'taraz',
                                        ],
                                        title => <th
                                            rowSpan='2'
                                            key={title}
                                            style={{ ...defaultStyles.th, width: title.includes('score') ? '5.5em' : '4em' }}>
                                            {window.gettext(_.startCase(title))}
                                        </th>,
                                    )}
                                    <th colSpan='3' style={{ borderBottom: ".0625em solid #888888", paddingTop: "0.3em", paddingBottom: "0.3em", width: '4em' }}>
                                        <div style={{ width: "100%" }}>
                                            <div style={{ backgroundColor: "#cccccc", display: "flex", justifyContent: "center", width: "100%", borderBottom: ".0625em solid #888888" }}>
                                                <span style={{ flex: 1 }}>کلاس</span>
                                            </div>
                                            <div style={{ backgroundColor: "#cccccc", display: "flex", justifyContent: "center", width: "100%" }}>
                                                <span style={{ flex: 1 }}>کلاس</span>
                                                <span style={{ flex: 1 }}>مدرسه</span>
                                                <span style={{ flex: 1 }}>کشور</span>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {_.map(
                                    [..._.sortBy(this.props.examination.materials, material => materials.indexOf(material.title)), 'global'],
                                    material => {
                                        const data = material === 'global'
                                            ? this.props.data.global
                                            : this.props.data.materials[material.id];
                                        return data === undefined || data === null ? <></> : <tr
                                            style={defaultStyles.tr}
                                            key={material.id || material}>
                                            <td style={{ ...defaultStyles.td, width: '12em', textAlign: 'right' }}>
                                                {material === 'global' ? window.gettext('All') : material.title}
                                            </td>
                                            {showCoefficients
                                                ? <td style={{ ...defaultStyles.td, width: '4em', textAlign: 'center' }}>
                                                    {material === 'global'
                                                        ? _.sum(_.map(this.props.examination.materials_coefficients, value => Number(value))).persian()
                                                        : this.props.examination.materials_coefficients[material.id].persian()
                                                    }
                                                </td>
                                                : null
                                            }
                                            {_.map(
                                                ['count', 'correct', 'incorrect', 'empty', 'score', 'alternative_score', 'taraz'],
                                                title => <td
                                                    key={title}
                                                    style={{
                                                        ...defaultStyles.td,
                                                        width: title.includes('score') ? '5.5em' : '4em',
                                                        textAlign: 'center',
                                                    }}>
                                                    {(value => value !== undefined
                                                        ? title.includes('score')
                                                            ? value.toPercent().persian()
                                                            : value.toFixed().persian()
                                                        : '-'
                                                    )(data[title])}
                                                </td>,
                                            )}
                                            {_.map(
                                                ['class', 'school', 'global'],
                                                title => <td
                                                    key={title}
                                                    style={{
                                                        ...defaultStyles.td,
                                                        width: title.includes('score') ? '5.5em' : '4em',
                                                        textAlign: 'center',
                                                    }}>
                                                    {(value => value !== undefined
                                                        ? value.toFixed().persian()
                                                        : '-'
                                                    )((data[title] || {}).rank)}
                                                </td>,
                                            )}
                                        </tr>;
                                    },
                                )}
                            </tbody>
                        </table>
                    </div>
                    {/* start charts area */}
                    <div ref={(chartArea) => { this.chartArea = chartArea }} style={{ marginTop: ".6em" , marginBottom:".4em" }}>
                            {/* start bar chart */}
                            <div
                                style={{
                                    float: 'right',
                                    width: '40%',
                                    maxHeight: "180px",
                                }}>
                                <svg
                                    style={{
                                        maxHeight: "100%",
                                        // maxWidth: '100%',
                                        height: `${15 - Math.max(_.size(this.props.examination.materials), 5) * .5}em`,
                                        width: "auto",
                                        overflow: 'visible',
                                        direction: 'ltr',
                                        // marginTop: `${-.6 + (7 - Math.min(_.size(this.props.examination.materials), 7)) * .5}em`,
                                    }}
                                    viewBox={`0 -12 ${20 + (_.size(this.props.examination.materials) + 1) * 30 + 20} 150`}
                                    preserveAspectRatio='none'>
                                    <text
                                        style={{ fill: '#00ff44' }}
                                        x={(_.size(this.props.examination.materials) + 1) * 30}
                                        y='-12'
                                        dominantBaseline='hanging'
                                        textAnchor='start'
                                        fontSize='.6em'>
                                        {window.gettext('Global')}
                                    </text>
                                    <text
                                        style={{ fill: '#7cd0eb' }}
                                        x={(_.size(this.props.examination.materials) + 1) * 30 - 50}
                                        y='-12'
                                        dominantBaseline='hanging'
                                        textAnchor='start'
                                        fontSize='.6em'>
                                        {window.gettext('Student')}
                                    </text>
                                    {_.map(Array(6), (__, index) => [
                                        <text key={'text-' + index} x='18' y={index * 20} textAnchor='end' dominantBaseline='middle' fontSize='.6em'>
                                            ٪{index > 5 ? '-' : ''}{Math.abs((100 - index * 20)).persian()}
                                        </text>,
                                        <line key={'prefix-' + index} x1='19' y1={index * 20} x2='21' y2={index * 20} strokeWidth='1' stroke='black' />,
                                        <line
                                            key={'line-' + index}
                                            style={{
                                                strokeWidth: '1',
                                                stroke: 'rgba(0, 0, 0, .3)',
                                                strokeDasharray: '1',
                                            }}
                                            x1='20'
                                            y1={index * 20}
                                            x2={(_.size(this.props.examination.materials) + 1) * 30 + 20}
                                            y2={index * 20} />,
                                    ])}
                                    {_.map([...this.props.examination.materials, 'global'], (material, index) => {
                                        const data = material === 'global'
                                            ? this.props.data.global
                                            : this.props.data.materials[material.id];
                                        return data === undefined || data === null ? <></> : [
                                            <text
                                                key={'text-' + index}
                                                x={35 + 30 * index}
                                                y='104'
                                                transform={`rotate(60, ${35 + 30 * index}, 104)`}
                                                textAnchor='end'
                                                fontSize='.5em'
                                                class='rtl-style'>
                                                {material === 'global' ? window.gettext('All') : (material.title.substring(0, 8) +
                                                    (material.title.length > 8 ? '...' : ''))}
                                            </text>,
                                            data.score >= 0
                                                ? <rect
                                                    style={{ fill: '#7cd0eb', stroke: 'black', strokeWidth: '.5' }}
                                                    key={material + '-student'}
                                                    x={25 + 30 * index}
                                                    y={100 - data.score * 100}
                                                    width={10}
                                                    height={data.score * 100} />
                                                : <rect
                                                    style={{ fill: '#7cd0eb', stroke: 'black', strokeWidth: '.5' }}
                                                    key={material + '-student'}
                                                    x={25 + 30 * index}
                                                    y={100}
                                                    width={10}
                                                    height={-data.score * 100} />,
                                            this.props.data.global_score[material && material.id] >= 0
                                                ? <rect
                                                    style={{ fill: '#00ff44', stroke: 'black', strokeWidth: '.5' }}
                                                    key={material + '-global'}
                                                    x={35 + 30 * index}
                                                    y={100 - this.props.data.global_score[material && material.id] * 100}
                                                    width={10}
                                                    height={this.props.data.global_score[material && material.id] * 100 || 0} />
                                                : <rect
                                                    style={{ fill: '#00ff44', stroke: 'black', strokeWidth: '.5' }}
                                                    key={material + '-global'}
                                                    x={35 + 30 * index}
                                                    y={100}
                                                    width={10}
                                                    height={-this.props.data.global_score[material && material.id] * 100 || 0} />,
                                        ];
                                    })}
                                    <line x1='20' y1='-10' x2='20' y2='116' strokeWidth='1' stroke='black' />
                                    <line
                                        x1='20'
                                        y1='100'
                                        x2={(_.size(this.props.examination.materials) + 1) * 30 + 20}
                                        y2='100'
                                        strokeWidth='1'
                                        stroke='black' />
                                </svg>
                            </div>
                            {/* end bar Cahrt */}

                            {/* start other chart */}

                            {examinations.length > 0
                                ? _.uniqBy(examinations, (item) => item[2]).map((groupedExam, index) => {
                                    let filteredExaminations = examinations.filter((exam) => exam[2] == groupedExam[2]);
                                    const chartCountdData = Math.max(_.uniqBy(examinations, (item) => item[2]).length, this.state.chartCount);
                                    this.setState({ chartCount: chartCountdData });
                                    return [
                                        <div style={{ 
                                            // float: "right", 
                                            float:"left",
                                            maxWidth: "60%", marginRight: "-.2em", maxHeight: "190px" }}>
                                            <svg
                                                style={{
                                                    float: 'right',
                                                    width: 'auto',
                                                    maxWidth: "100%",
                                                    height: `${15 - Math.max(_.size(this.props.examination.materials), 5) * .5}em`,
                                                    maxHeight: "100%",
                                                    overflow: 'visible',
                                                    direction: 'ltr',
                                                }}
                                                viewBox={`0 -12 ${20 + (filteredExaminations.length + 1) * 30 + 20} 150`}
                                                preserveAspectRatio='none'>
                                                {_.map(Array(6), (__, index) => [
                                                    <text key={'text-' + index} x='18' y={index * 20} textAnchor='end' dominantBaseline='middle' fontSize='.6em'>
                                                        {(((index * minimumTaraz) +
                                                            ((5 - index) * maximumTaraz)) / 5).toFixed().persian()}
                                                    </text>,
                                                    <line key={'line-1-' + index} x1='19' y1={index * 20} x2='21' y2={index * 20} strokeWidth='1' stroke='black' />,
                                                    <line
                                                        key={'line-2-' + index}
                                                        style={{
                                                            strokeWidth: '1',
                                                            stroke: 'rgba(0, 0, 0, .3)',
                                                            strokeDasharray: '1',
                                                        }}
                                                        x1='20'
                                                        y1={index * 20}
                                                        x2={(filteredExaminations.length + 1) * 30 + 20}
                                                        y2={index * 20} />,
                                                ])}
                                                {_.map(
                                                    _.zip(filteredExaminations, _.concat(_.slice(filteredExaminations, 1), [[]])),
                                                    ([[title, taraz], [, nextTaraz]], index) => {
                                                        const elements = [
                                                            <text
                                                                key={'text-' + index}
                                                                x={35 + 30 * index}
                                                                y='104'
                                                                transform={`rotate(60, ${35 + 30 * index}, 104)`}
                                                                textAnchor='end'
                                                                fontSize='.4em'
                                                                class='rtl-style'>
                                                                {(title.substr(0, 14) + (title.length > 14 ? '...' : ''))}
                                                            </text>,
                                                        ];
                                                        elements.push(<circle
                                                            key={index + '-dot'}
                                                            cx={35 + 30 * index}
                                                            cy={100 - (taraz - minimumTaraz) / (maximumTaraz - minimumTaraz) * 100}
                                                            r={2}
                                                            style={{ fill: '#7cd0eb' }} />);
                                                        if (nextTaraz)
                                                            elements.push(<line
                                                                key={index + '-line'}
                                                                x1={35 + 30 * index}
                                                                y1={100 - (taraz - minimumTaraz) / (maximumTaraz - minimumTaraz) * 100}
                                                                x2={35 + 30 * (index + 1)}
                                                                y2={100 - (nextTaraz - minimumTaraz) / (maximumTaraz - minimumTaraz) * 100}
                                                                strokeWidth='1'
                                                                stroke='#7cd0eb'
                                                            />);
                                                        return elements;
                                                    },
                                                )}
                                                <line x1='20' y1='-10' x2='20' y2='116' strokeWidth='1' stroke='black' />
                                                <line
                                                    x1='20'
                                                    y1='100'
                                                    x2={(filteredExaminations.length + 1) * 30 + 20}
                                                    y2='100'
                                                    strokeWidth='1'
                                                    stroke='black' />
                                            </svg>
                                        </div>

                                    ]
                                })
                                : null
                            }
                            <div style={{ clear: "both" }}></div>
                            {/* end other cagrt */}
                        </div>
                        {/* end chart area */}
                    {/* start rank table */}
                    {/* {
                    this.props.examination.examination_type.id === 6 && this.props.shabihsazData && <div style={{display:"flex" , justifyContent:"center" , width:"100%"}}>
                    <table 
                    ref={(rankTable)=>{this.rankTable = rankTable}}
                    style={{  ...defaultStyles.table,
                                fontSize: `${.9 - Math.max(_.size(this.props.examination.materials), 5) * .03}em`, 
                                marginTop: '1em' ,
                                width:`100%` }}>
                        <thead style={{ backgroundColor: '#cccccc' }}>
                             {_.map(this.props.shabihsazData.examinations , (item)=>(
                                <th style={{ ...defaultStyles.th, width: '12em' }} colSpan={3}>
                                    {window.gettext(`Ranking with schools formula ${item.title}`)}
                                </th>
                         ))}
                        </thead>
                        <tbody>
                            <tr style={defaultStyles.tr}>
                                {_.map(this.props.shabihsazData.examinations , _ =>
                                    ["تراز","رتبه کل" ,`رتبه در ${this.props.shabihsazData.examinations.gender == 1 ? "پسران" : "دختران"}`].map((item)=>(
                                        <th style={{ ...defaultStyles.td, width: '12em', textAlign: 'center'}}>
                                            {window.gettext(item)}
                                        </th>
                             )))}
                            </tr>
                            <tr style={defaultStyles.tr}>
                                {_.map(this.props.shabihsazData.examinations , (item)=>(
                                <>
                                    <td style={{ ...defaultStyles.td, width: '12em', textAlign: 'center'}}>
                                        {window.gettext(item.taraz.toFixed().persian())}
                                    </td>
                                    <td style={{ ...defaultStyles.td, width: '12em', textAlign: 'center'}}>
                                        {window.gettext(item.rank.global_.persian())}
                                    </td>
                                    <td style={{ ...defaultStyles.td, width: '12em', textAlign: 'center'}}>
                                        {window.gettext(item.rank.gender.persian())}
                                    </td>
                                 </>
                             ))}
                            </tr>
                        </tbody>
                    </table>
                </div>
            } */}
                    <div style={{
                        marginTop: `0.2em`,
                        overflow: 'hidden',
                    }}>
                        <div style={{ display: "flex", width: "100%", justifyContent: "space-around", marginBottom: "0.3cm", }}
                        ref={(answers)=>{this.answers = answers}}
                        >
                            {/* start examination image */}
                            {this.state.noImage
                                ? <div
                                    style={{
                                        display: 'flex',
                                        height: this.props.examination.paper_type === 14 ? '20em' : '12.5em',
                                        width: this.props.examination.paper_type === 14 ? '16em' : '9em',
                                        marginLeft: '.1em',
                                        float: 'right',
                                        border: '.0625em solid #9a9a9a',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}>
                                    {window.gettext('No paper image for this examination!')}
                                </div>
                                : <img
                                    style={{
                                        display: 'block',
                                        height: this.props.examination.paper_type === 14 ? '20em' : '12.5em',
                                        width: this.props.examination.paper_type === 14 ? '16em' : '9em',
                                        marginLeft: '.1em',
                                        float: 'right',
                                    }}
                                    src={imageUrl(this.props.data.image, {
                                        height: (this.props.examination.paper_type === 14 ? 34 : 13) * 16,
                                        type: 'contain',
                                    })}
                                    onLoad={this.props.imageLoaded}
                                    onError={() => this.setState({ noImage: true }, this.props.imageLoaded)}
                                />
                            }

                            {/* end examination image */}

                            <div
                                style={{
                                    float: 'right',
                                    fontSize: '.8em',
                                    marginRight: '-.4em',
                                }}>
                                <div style={{ height: '4em', lineHeight: '1.2em', fontSize: '.75em' }}>
                                    <div
                                        style={{
                                            width: '12px',
                                            height: '8px',
                                            border: '1px solid black',
                                            boxSizing: 'border-box',
                                            backgroundColor: 'green',
                                            float: 'right',
                                        }}>
                                        <svg style={{ margin: '-1px' }} viewBox='0 0 1250 900'>
                                            <path style={{ fill: '#ffffff' }} d='M977 46l21 26c-87,55 -183,142 -289,257 -106,117 -187,225 -244,325l-45 26c-38,22 -63,38 -76,49 -6,-17 -17,-43 -35,-79l-17 -34c-24,-48 -46,-84 -68,-107 -21,-23 -44,-38 -70,-46 44,-40 84,-59 120,-59 31,0 66,36 104,108l18 36c69,-99 156,-195 263,-287 107,-93 213,-165 315,-214l1 -2z' />
                                        </svg>
                                    </div>&nbsp;
                                    {window.gettext('Correct answer filled by student')}
                                    <br />
                                    <div
                                        style={{
                                            width: '12px',
                                            height: '8px',
                                            border: '1px solid black',
                                            boxSizing: 'border-box',
                                            backgroundColor: '#ed3237',
                                            float: 'right',
                                        }}>
                                        <svg style={{ margin: '-1px' }} viewBox='0 0 1250 900'>
                                            <path style={{ fill: '#ffffff' }} d='M584 523l-10 14c-67,102 -122,153 -165,153 -49,0 -98,-40 -146,-121 6,0 11,1 14,1 56,0 119,-43 188,-129l18 -22 -23 -24c-63,-67 -95,-124 -95,-171 0,-38 35,-84 104,-136 10,67 39,132 89,195l19 25 15 -20c72,-92 137,-138 196,-138 46,0 80,35 104,104 -7,-1 -12,-1 -15,-1 -21,0 -50,14 -87,42 -37,28 -69,59 -95,94l-19 26 19 18c69,67 142,100 217,100 -41,82 -83,123 -126,123 -40,0 -97,-35 -172,-105l-30 -27z' />
                                        </svg>
                                    </div>&nbsp;
                                    {window.gettext('Incorrect answer filled by student')}
                                    <br />
                                    <div
                                        style={{
                                            width: '12px',
                                            height: '8px',
                                            border: '1px solid black',
                                            boxSizing: 'border-box',
                                            backgroundColor: '#ffffff',
                                            float: 'right',
                                        }}>
                                        <svg style={{ margin: '-1px' }} viewBox='0 0 1250 900'>
                                            <path style={{ fill: 'green' }} d='M977 46l21 26c-87,55 -183,142 -289,257 -106,117 -187,225 -244,325l-45 26c-38,22 -63,38 -76,49 -6,-17 -17,-43 -35,-79l-17 -34c-24,-48 -46,-84 -68,-107 -21,-23 -44,-38 -70,-46 44,-40 84,-59 120,-59 31,0 66,36 104,108l18 36c69,-99 156,-195 263,-287 107,-93 213,-165 315,-214l1 -2z' />
                                        </svg>
                                    </div>&nbsp;
                                    {window.gettext('Correct answer not filled by student')}
                                </div>
                                {/* start answers Box */}
                                <div>
                                    {/* change code */}
                                    {_.map(Array(columns), (value, column) => <div
                                        key={column}
                                        style={{
                                            float: 'left',
                                            marginRight: '.3em',
                                            fontSize: '.9em',
                                            lineHeight: '1em',
                                        }}>
                                        {_.map(
                                            Array(questionsPerColumn),
                                            (value, row) => (this.props.data.questions[column * questionsPerColumn + row] || { options: 0 }).options > 0
                                                ? <div
                                                    key={row}
                                                    style={{ overflow: 'hidden' }}>
                                                    <div
                                                        dir='ltr'
                                                        style={{
                                                            width: '1.5em',
                                                            float: 'left',
                                                            marginBottom: '-.08em',
                                                            fontSize: '.85em',
                                                        }}>
                                                        {(column * questionsPerColumn + row + 1).persian()}.
                                                    </div>
                                                    {_.map(
                                                        Array((this.props.data.questions[column * questionsPerColumn + row] || { options: 0 }).options),
                                                        (value, option) => <div
                                                            key={option}
                                                            style={{
                                                                width: '12px',
                                                                height: '8px',
                                                                marginLeft: '.05em',
                                                                marginRight: '.05em',
                                                                marginTop: '0',
                                                                marginBottom: '0',
                                                                float: 'left',
                                                                border: '1px solid black',
                                                                boxSizing: 'border-box',
                                                                backgroundColor: this.props.data.questions[column * questionsPerColumn + row]
                                                                    ? this.props.data.answers[column * questionsPerColumn + row] & (1 << option)
                                                                        ? this.props.data.key[column * questionsPerColumn + row] === '0'
                                                                            ? undefined
                                                                            : this.props.data.key[column * questionsPerColumn + row] & (1 << option)
                                                                                ? 'green'
                                                                                : '#ed3237'
                                                                        : undefined
                                                                    : '#dddddd',
                                                            }}>
                                                            <svg style={{ margin: '-1px' }} viewBox='0 0 1250 900'>
                                                                {this.props.data.questions[column * questionsPerColumn + row]
                                                                    ? this.props.data.key[column * questionsPerColumn + row] & (1 << option)
                                                                        ? this.props.data.answers[column * questionsPerColumn + row] & (1 << option)
                                                                            ? <path style={{ fill: '#ffffff' }} d='M977 46l21 26c-87,55 -183,142 -289,257 -106,117 -187,225 -244,325l-45 26c-38,22 -63,38 -76,49 -6,-17 -17,-43 -35,-79l-17 -34c-24,-48 -46,-84 -68,-107 -21,-23 -44,-38 -70,-46 44,-40 84,-59 120,-59 31,0 66,36 104,108l18 36c69,-99 156,-195 263,-287 107,-93 213,-165 315,-214l1 -2z' />
                                                                            : <path style={{ fill: 'green' }} d='M977 46l21 26c-87,55 -183,142 -289,257 -106,117 -187,225 -244,325l-45 26c-38,22 -63,38 -76,49 -6,-17 -17,-43 -35,-79l-17 -34c-24,-48 -46,-84 -68,-107 -21,-23 -44,-38 -70,-46 44,-40 84,-59 120,-59 31,0 66,36 104,108l18 36c69,-99 156,-195 263,-287 107,-93 213,-165 315,-214l1 -2z' />
                                                                        : this.props.data.answers[column * questionsPerColumn + row] & (1 << option)
                                                                            ? <path style={{ fill: '#ffffff' }} d='M584 523l-10 14c-67,102 -122,153 -165,153 -49,0 -98,-40 -146,-121 6,0 11,1 14,1 56,0 119,-43 188,-129l18 -22 -23 -24c-63,-67 -95,-124 -95,-171 0,-38 35,-84 104,-136 10,67 39,132 89,195l19 25 15 -20c72,-92 137,-138 196,-138 46,0 80,35 104,104 -7,-1 -12,-1 -15,-1 -21,0 -50,14 -87,42 -37,28 -69,59 -95,94l-19 26 19 18c69,67 142,100 217,100 -41,82 -83,123 -126,123 -40,0 -97,-35 -172,-105l-30 -27z' />
                                                                            : null
                                                                    : null
                                                                }
                                                            </svg>
                                                        </div>,
                                                    )}
                                                </div>
                                                : null
                                        )}
                                    </div>)}
                                </div>
                                {/* end answers box */}
                            </div>

                        </div>
                    </div>
                    <div style={{ height: `${this.state.freeHeight}mm` }}></div>
                    {this.questionsList()}
                </div>

            </div>

        </>;
    }
};
